// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"b3d826f5","296":"dd7e325b","826":"29a6c9a0"}[chunkId] + ".chunk.js";
};